import { useContext } from 'react';
import { Metric, MetricTotalsByDate } from '@blisspointmedia/bpm-types/dist/CrossChannel';
import { SparkChart } from '@Components/SparkChart/SparkChart';
import { CrossChannelContext } from '../cross-channel-context';
import { DEFAULT_SPARKCHARTS_MAP, METRIC_OPTIONS } from '../cross-channel-constants';
import { CompareMetrics } from '../Components/CompareMetrics';

interface OverviewProps {
  data: MetricTotalsByDate[];
  otherData: MetricTotalsByDate[];
  defaultCompareMetrics: Metric[] | undefined;
  defaultCompareMetricsIncludeOtherDates?: boolean;
  defaultSparkCharts?: readonly Metric[];
}

export const DEFAULT_METRICS = DEFAULT_SPARKCHARTS_MAP['cross-channel'];

export const Overview = ({
  data,
  otherData,
  defaultCompareMetrics,
  defaultCompareMetricsIncludeOtherDates = false,
  defaultSparkCharts = DEFAULT_METRICS
}: OverviewProps) => {
  const { kpi, dataInfo, pagePreset } = useContext(CrossChannelContext);

  // In the DB, sparkChartTypes is an array of "Total" | "Avg" | false
  const sparkChartsConfig = pagePreset?.globalOptions?.sparkChartTypes || [
    'Total',
    'Total',
    'Total',
    'Total'
  ];

  return (
    <div className='cc-overview'>
      <div className='cc-top-section'>
        <div className='cc-top-section-left-side'>
          <div className='cc-spark-charts'>
            {defaultSparkCharts.slice(0, DEFAULT_METRICS.length).map((metric, index) => (
              <SparkChart
                pngLabel={`KPI: ${kpi}`}
                pngFileIdentifiers={['CrossChannel']}
                data={data}
                otherData={otherData}
                defaultMetric={metric}
                key={metric}
                metricOptions={METRIC_OPTIONS}
                dataInfo={dataInfo}
                defaultValueToggle={sparkChartsConfig[index] || 'Total'}
              />
            ))}
          </div>
        </div>
      </div>
      <div className='cc-row'>
        <div className='cc-agency-news'>
          <a
            href='https://info.tinuiti.com/incrementality_playbook_2025?utm_source=tinuiti&utm_medium=blisspointapp&utm_campaign=G-25-08-26-ALL-Incrementality-Playbook'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              className='cc-agency-news-image'
              src='https://cdn.blisspointmedia.com/agencies/tinuiti/incrementality_playbook.png'
              alt='Agency News'
              width={500}
              height={500}
            />
          </a>
        </div>
        <div className='cc-metric-comparison-chart'>
          <CompareMetrics
            pngDownloadLabel={`KPI: ${kpi}`}
            pngFileIdentifiers={['CrossChannel']}
            data={data}
            otherData={otherData}
            defaultMetrics={defaultCompareMetrics}
            defaultIncludeOtherDates={defaultCompareMetricsIncludeOtherDates}
            includeFooter
            metricOptions={METRIC_OPTIONS}
          />
        </div>
      </div>
    </div>
  );
};
